import {clone} from 'schemaDefinition/functions/clone';
import {getId} from 'services/utils';
import type {ExpressionV4} from '../types';

export const createExpression = (source: ExpressionV4): ExpressionV4 => {
  const newExpression = clone(source);
  newExpression.id = getId();
  newExpression.created = 0;
  newExpression.modified = 0;
  return newExpression;
};
